function parseHiddenString(node) {
  var hiddenNode;
  if (typeof node === 'string' && typeof document !== 'undefined') {
    hiddenNode = document.querySelector(node);
  } else if (node) {
    hiddenNode = node;
  }
  if (hiddenNode) {
    /*
        Use the first comment DOM node, if present.
        Otherwise fallback to the raw text content of the hiddenNode itself.
    */
    var commentNode = null;
    for (var ix = 0; ix < hiddenNode.childNodes.length; ix++) {
      var childNode = hiddenNode.childNodes[ix];
      if (childNode.nodeType === Node.COMMENT_NODE) {
        commentNode = childNode;
        break;
      }
    }
    var s = (commentNode ? commentNode.textContent : hiddenNode.innerHTML).trim();
    return s.replace(/\\-/g, '-').replace(/\\</g, '<').replace(/\\"/g, '"').replace(/\\>/g, '>');
  }
  return null;
}
function parseHiddenJSON(node) {
  try {
    return JSON.parse(parseHiddenString(node));
  } catch (e) {
    return null;
  }
}

export { parseHiddenJSON, parseHiddenString };
